import {
  Box,
  Button,
  ButtonProps,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';

type MediaObjectProps = {
  img: string;
  direction?: 'row' | 'row-reverse';
  heading: string;
  headingSecondary: string;
  text: string;
  buttons: ButtonProps[];
};

export const MediaObject = ({
  img,
  direction,
  heading = 'row',
  headingSecondary,
  text,
  buttons,
}: MediaObjectProps) => {
  const theme = useTheme();
  return (
    <Grid container spacing={6} alignItems="center" direction={direction}>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: { xs: '300px', md: '400px' },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: `0 20px 40px ${theme.palette.mainColors.background}`,
              border: `1px solid ${theme.palette.greyShades.border1}`,
            }}
          >
            <img
              alt="feature illustration"
              src={img}
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '500px',
                display: 'block',
              }}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            height: '100%',
            justifyContent: 'center',
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                color: theme.palette.text.primary,
                fontSize: { xs: '1.75rem', md: '2.25rem', lg: '2.5rem' },
                fontWeight: 700,
                lineHeight: 1.2,
                mb: 1,
              }}
            >
              {heading}{' '}
              <span style={{ color: theme.palette.mainColors.primary }}>
                {headingSecondary}
              </span>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.greyShades.grey1,
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.7,
                maxWidth: '500px',
              }}
            >
              {text}
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '16px',
              mt: 2,
            }}
          >
            {buttons.map((button, idx) => (
              <Button
                key={idx}
                size="large"
                variant={idx === 0 ? 'contained' : 'outlined'}
                sx={{
                  minWidth: { xs: '100%', sm: 'auto' },
                  px: 3,
                  py: 1.5,
                  borderRadius: '8px',
                  fontWeight: 600,
                  ...button.sx,
                }}
                {...button}
              />
            ))}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
